export default __webpack_public_path__ + "static/home-slide-small003-3aa8c4e661a9a69ad0e15d125fd956d0.jpg";